var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlgorithm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.25 9h-7.5c-.414 0-.75-.336-.75-.75v-7.5c0-.414.336-.75.75-.75h7.5c.414 0 .75.336.75.75v7.5c0 .414-.336.75-.75.75zm-6.75-1.5h6v-6h-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19 17c-.192 0-.384-.073-.53-.22l-4.25-4.25c-.293-.293-.293-.768 0-1.061l4.25-4.25c.293-.293.768-.293 1.061 0l4.25 4.25c.293.293.293.768 0 1.061l-4.25 4.25c-.147.147-.339.22-.531.22zm-3.189-5 3.189 3.189 3.189-3.189-3.189-3.189z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.5 24c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zm0-7.5c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m19 8.25c-.414 0-.75-.336-.75-.75v-2.25h-9.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10.5c.414 0 .75.336.75.75v3c0 .414-.336.75-.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m19 20.25h-10.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h9.75v-2.25c0-.414.336-.75.75-.75s.75.336.75.75v3c0 .414-.336.75-.75.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorithm);
export default __webpack_public_path__ + "static/media/algorithm.2857ea5cb289f0db8b1d404ea697e6e7.svg";
export { ForwardRef as ReactComponent };